import { InvalidPage } from 'assessment/pages/components';
import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { store } from '@/store';
import { customTheme } from '@/theme';

const CandidateSurvey = lazy(() =>
  import(/* webpackChunkName: "CandidateSUrvey"*/ '../pages/')
);

const routes = [
  {
    route: '/:accountId/surveys/:candidateSurveyId',
    component: CandidateSurvey,
  },
];

// Create a query client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      refetchOnWindowFocus: false,
    },
  },
});

export const CandidateSurveyRoutes = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={customTheme}>
          <Switch>
            {routes.map((item, idx) => {
              const Component = item.component;
              return (
                <Route key={idx} path={item.route}>
                  <Component />
                </Route>
              );
            })}
            <Route path="*">
              <InvalidPage />
            </Route>
          </Switch>
        </ChakraProvider>
      </QueryClientProvider>
    </Provider>
  );
};
